import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import Shell from "../Shell";
import { authHeaders } from "../api";

export default function ApproveList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRows = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/pending-users/", {
        params: { status: "pending" },
        headers: authHeaders(),
      });
      setRows(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchRows(); }, []);

  const approve = async (id) => {
    if (!window.confirm("Samþykkja þennan notanda?")) return;
    try {
        await api.post(`/api/pending-users/${id}/approve/`, {}, { headers: authHeaders() });
        // remove the row on success
        setRows((r) => r.filter((x) => x.id !== id));
    } catch (err) {
        const msg =
        err.response?.data?.errors ||
        err.response?.data?.detail ||
        err.response?.data?.trace ||
        "Upp kom villa við samþykki.";
        alert(typeof msg === "string" ? msg : JSON.stringify(msg));
    }
  };

  return (
    <Shell title="Hugarafl starfsfólk" rightMenu menuItems={[
      {title:"Samþykkja nýjan félagsaðila", to:"/members/approve"},
      {title:"Skrá viðtöl", to:"/interviews/new"},
      {title:"Yfirlit yfir félagsaðila", to:"/members"},
      {title:"Yfirlit yfir hópa", to:"/groups"},
      {title:"Skrá mætingu í hóp", to:"/attendance/group"},
      {title:"Heildaryfirlit yfir mætingu", to:"/attendance/summary"},
      {title:"Skrá atvik", to:"/incidents/new"},
    ]}>
      <h2 style={{textAlign:"center", margin:"8px 0 18px"}}>Samþykkja nýjan félagsaðila</h2>

      {loading ? <div>Hleð…</div> : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Nafn</th>
                <th>Notendanafn</th>
                <th>Símanúmer</th>
                <th>Email</th>
                <th style={{width:180}}></th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr><td colSpan={5} style={{textAlign:"center", padding:"20px"}}>Engar beiðnir í bið</td></tr>
              ) : rows.map(r => (
                <tr key={r.id}>
                  <td>{r.full_name}</td>
                  <td>{r.username}</td>
                  <td>{r.phone_number}</td>
                  <td>{r.email}</td>
                  <td style={{textAlign:"right", whiteSpace:"nowrap"}}>
                    <Link className="btn ghost sm" to={`/members/approve/${r.id}`}>Nánar</Link>{" "}
                    <button className="btn sm" onClick={() => approve(r.id)}>Samþykkja</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Shell>
  );
}